angular.module('cfn').service('farmService', [
  '$log',
  '$http',
  function($log, $http) {
    'use strict';

    this.getFarms = function(
             withActive = true,
             withInactive = false,
             resultFields = ['id', 'active', 'name', 'number']
             ) {
  	return $http.get('/365FarmNet/mod/coredata-service/rest/service/v1.0/farms/?resultFields=list%5B' 
      + resultFields.join() + '%5D&withActive=' + withActive + '&withInactive=' + withInactive 
      + '&count=1000&fixedErrorStatus=true&sortField=name');
  }

  }
]);
